// @flow

import * as React from 'react';
import Responsive from 'react-responsive';

import ProgressiveImage from '../ProgressiveImage/ProgressiveImage';

type Props = {
  src: string,
  thumbnail: string,
  alt?: string,
  aspectRatio: string,
  designedPortraitMobileHeight?: number,
  designedLandscapeMobileHeight?: number,
}

class ResponsiveImage extends React.Component<Props> {
  static defaultProps = {
    alt: '',
    designedPortraitMobileHeight: 180,
    designedLandscapeMobileHeight: 240,
  }

  render() {
    const { aspectRatio, designedPortraitMobileHeight, designedLandscapeMobileHeight } = this.props;

    const portraitMobileWidth = (designedPortraitMobileHeight * 100) / parseFloat(aspectRatio);

    const portraitMobileImageStyle = {
      width: `${portraitMobileWidth}px`,
      left: '50%',
      marginLeft: `${-portraitMobileWidth / 2}px`,
    };

    const landscapeMobileWidth = (designedLandscapeMobileHeight * 100) / parseFloat(aspectRatio);

    const landscapeMobileImageStyle = {
      width: `${landscapeMobileWidth}px`,
      left: '50%',
      marginLeft: `${-landscapeMobileWidth / 2}px`,
    };

    const deskTopProps = {
      ...this.props,
      designedMobileHeight: null,
    };

    const portraitMobileProps = {
      ...this.props,
      autoHeight: false,
      designedMobileHeight: designedPortraitMobileHeight,
      mobileImageStyle: portraitMobileImageStyle,
    };

    const landscapeMobileProps = {
      ...this.props,
      autoHeight: false,
      designedMobileHeight: designedLandscapeMobileHeight,
      mobileImageStyle: landscapeMobileImageStyle,
    };

    return (
      <div className="responsive-image">
        <Responsive minWidth={768}>
          <ProgressiveImage {...deskTopProps} />
        </Responsive>
        <Responsive minWidth={480} maxWidth={767}>
          <ProgressiveImage {...landscapeMobileProps} />
        </Responsive>
        <Responsive maxWidth={479}>
          <ProgressiveImage {...portraitMobileProps} />
        </Responsive>
      </div>
    );
  }
}

export default ResponsiveImage;
